var _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHr = function SvgHr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#48aaf8dd-ea08-4814-9392-e0028977221ea)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "167936c7-45b9-47d6-afb3-7502cc9ed82bb",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#167936c7-45b9-47d6-afb3-7502cc9ed82bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#150A99",
    fillRule: "evenodd",
    d: "M0 10h21v5H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M0 0h21v5H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0091E0",
    fillRule: "evenodd",
    d: "M8 4h1v1H8zm2-1h1v2h-1zm2 1h1v1h-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#150A99",
    fillRule: "evenodd",
    d: "M11 3h1v2h-1zM9 3h1v2H9z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "a5afed6d-c418-46de-a8c0-a58e1646009ac",
    width: 5,
    height: 6,
    x: 8,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 8.5a2.5 2.5 0 0 1-5 0V5h5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a5afed6d-c418-46de-a8c0-a58e1646009ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M13 8.5a2.5 2.5 0 0 1-5 0V5h5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 10h1v1H9zm2 0h1v1h-1zm-1-1h1v1h-1zM9 8h1v1H9zm2 0h1v1h-1zm-1-1h1v1h-1zM9 6h1v1H9zm2 0h1v1h-1zm-1-1h1v1h-1zm2 0h1v1h-1zm0 2h1v1h-1zm0 2h1v1h-1zM8 9h1v1H8zm0-2h1v1H8zm0-2h1v1H8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "48aaf8dd-ea08-4814-9392-e0028977221ea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgHr;